const toggleSearch = (value = false) => {
  document.body.classList.toggle('is-open-search', value);
  document.querySelector('.header-search__input-field')[value ? 'focus' : 'blur']();
};

attachEvent('.header-main__search-btn', 'click', () => {
  toggleSearch(true);
});

attachEvent('.header-search__close', 'click', () => {
  toggleSearch(false);
});

document.addEventListener('keydown', ({ key }) => {
  if (key === 'Escape') {
    toggleSearch(false);
  }
});

// const headerSearch = document.querySelectorAll('.header-search__input-field');
//
// headerSearch.forEach((input) => {
//   const parent = input.closest('.header-search');
//
//   const filterHeaderResults = (input) => {
//     const searchValue = input.value.toLowerCase();
//     const categories = parent.querySelectorAll('.header-search__items');
//
//     categories.forEach((category) => {
//       const items = category.querySelectorAll('.header-search__item');
//       let hasVisibleItems = false;
//
//       items.forEach((option) => {
//         const itemText = option.innerHTML.toLowerCase();
//         const isMatch = searchValue.length >= 2 && itemText.includes(searchValue);
//         option.style.display = isMatch ? 'grid' : 'none';
//         if (isMatch) hasVisibleItems = true;
//       });
//
//       category.classList.toggle('is-hidden', !hasVisibleItems);
//     });
//   };
//
//   input.addEventListener('input', () => filterHeaderResults(input));
// });

const searchHeaderPosts = (search) => {
  if (search.value) {
    axios
      .post(
        localData.apiURL,
        {
          action: 'searchPostsHeader',
          s: search.value,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          document.querySelector('.header-search__results').innerHTML = response.data.data.html;
        }
      });
  }
};
const searchField = document.querySelector('input#search');
if (searchField) {
  searchField.addEventListener(
    'keyup',
    debounce(() => {
      searchHeaderPosts(searchField);
    }, 200),
  );
}

const searchInputs = document.querySelectorAll('.header-search__input-field');
searchInputs.forEach((input) => {
  const parent = input.closest('.header-search');
  input.addEventListener('focus', () => {
    parent.classList.add('is-focused');
  });

  input.addEventListener('blur', () => {
    setTimeout(() => {
      parent.classList.remove('is-focused');
    }, 150);
  });
});
